import { client } from '../http';

export default {
  async fetchSubscriptionState() {
    const response = await client.get('/api/subscription-state');
    return response.data;
  },

  async fetchFirstBillingDate() {
    const response = await client.get('/api/subscription-state/first-billing-date');
    return response.data;
  },

  async createBenefit(promotion) {
    const response = await client.post('/api/subscription-state/benefit', { promotion });
    return response.data;
  },

  async redeemBenefit(promotion) {
    const response = await client.put('/api/subscription-state/benefit', { promotion });
    return response.data;
  },
};




// WEBPACK FOOTER //
// ./src/api/SubscriptionStateApi.js